module.exports = __webpack_public_path__ + "static/media/device-icons.f334e8d6ca158e18e1f47d5f3b636412393fb2c61107597f56b930720b688aea.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/device-icons.woff2
// module id = 2362
// module chunks = 204